export default {
    name : 'privacy-links',
    _elements: null,

    init() {
        this._elements = document.querySelectorAll('.js_privacy-link');
        if (!this._elements) {
            return;
        }

        for (const el of this._elements) {
            el.addEventListener('click', (i) => {
                const linkId = (typeof i.target.dataset.rel !== 'undefined') ? i.target.dataset.rel : null;
                const link = document.getElementById(linkId);

                if (link) {
                    link.innerHTML = i.target.dataset.value;
                    link.href = link.href + i.target.dataset.value.replaceAll(' ', '');

                    i.target.remove();
                }
            });
        }
    },
}